import type { SetOptional } from 'type-fest'
import { createActionCreator, createVoidActionCreator } from '../common/actions'
import type { DownloaderState, ModalStatus } from './reducer'

export const SetDownloaderModalStatus = createActionCreator<ModalStatus>(
    'DOWNLOADER_MODAL_STATUS_UPDATED',
)
export const SetClickedLinkStatus = createActionCreator<number>(
    'DOWNLOADER_PAGE_LINK_STATUS_UPDATED',
)
type StartPaginatedDownloadFlowPayload = SetOptional<
    DownloaderState,
    'convert' | 'subrevisions' | 'isFromTrash'
>
export const StartPaginatedDownloadFlow =
    createActionCreator<StartPaginatedDownloadFlowPayload>(
        'START_PAGINATED_DOWNLOAD_FLOW',
    )
export const ClearDownloaderState = createVoidActionCreator(
    'DOWNLOADER_STATE_CLEARED',
)
